import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CSS/ThankYou.css';

const ThankYou = () => {
    const [confetti, setConfetti] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/');
        }, 8000);
        return () => clearTimeout(timer);
    }, [navigate]);

    useEffect(() => {
        const colors = [
            '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA502',
            '#FF69B4', '#FFD93D', '#6BCB77', '#A8E6CF'
        ];

        const createConfetti = () => {
            const piece = {
                id: Math.random(),
                left: Math.random() * 100,
                delay: Math.random() * 0.3,
                duration: 2.5 + Math.random() * 1,
                rotate: Math.random() * 360,
                size: 8 + Math.random() * 8,
                color: colors[Math.floor(Math.random() * colors.length)],
                xOffset: (Math.random() - 0.5) * 100
            };
            setConfetti(prev => [...prev, piece]);
        };

        const interval = setInterval(createConfetti, 30);

        const stopTimeout = setTimeout(() => {
            clearInterval(interval);
        }, 2000);

        return () => {
            clearInterval(interval);
            clearTimeout(stopTimeout);
        };
    }, []);

    return (
        <div className="thank-you-page">
            <div className="confetti-container">
                {confetti.map(piece => (
                    <div
                        key={piece.id}
                        className="confetti-piece"
                        style={{
                            left: `${piece.left}%`,
                            '--delay': `${piece.delay}s`,
                            '--duration': `${piece.duration}s`,
                            '--rotate': `${piece.rotate}deg`,
                            '--size': `${piece.size}px`,
                            '--color': piece.color,
                            '--xOffset': `${piece.xOffset}px`
                        }}
                    />
                ))}
            </div>

            <div className="thank-you-container">
                <div className="checkmark-circle">
                    <div className="checkmark"></div>
                </div>
                <h1>Thank You!</h1>
                <p>Your order has been successfully placed.</p>
                <p>We're preparing your items and will notify you soon.</p>

                <button className="home-button" onClick={() => navigate('/')}>
                    Back to Shopping
                </button>
            </div>
        </div>
    );
};

export default ThankYou;